import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { ButtonConfig } from 'src/app/models/button.component.model';
import { FormControl } from '@angular/forms';
import * as moment from 'moment';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

import { Moment } from 'moment';
import { MatDatepicker } from '@angular/material/datepicker';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { AlertService, Constants } from 'src/app/shared/index';
import { tap, catchError, windowCount } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
@Component({
  selector: 'app-report-filter',
  templateUrl: './solar-daily-report.component.html',
  styleUrls: ['./solar-daily-report.component.scss']
})
export class SolarDailyReportComponent implements OnInit, OnDestroy {
  siteId = '';
  startView = 'month';
  minView = 'day';
  date = new FormControl(new Date());
  reportType: string;
  navigationSubscription: any;
  max = new Date();
  constructor(public commonService: CommonService, private activeRoute: ActivatedRoute,
    private dataService: DataService, private _http: HttpClient,
    private alertService: AlertService, private router: Router) {
    
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      // console.log('Router event:', e);
      if (e instanceof (NavigationEnd)) {
        this.siteId = localStorage.getItem('siteId');
        this.reportType = this.activeRoute.snapshot.paramMap.get('type');
        // console.log('reportType:', this.reportType);
      }

    });
  }
  ngOnInit() {

  }
  ngOnDestroy() {
    if (this.navigationSubscription) {
       this.navigationSubscription.unsubscribe();
    }
  }
  ok() {
    let url = '';
    if (this.date.value) {
      const selecteddate = moment(this.date.value).format('YYYY-MM-DD');

      switch (this.reportType) {
        case 'solar':
          url = this.commonService.getgenerateDailySolarReportUrl(this.siteId, selecteddate);
          break;
        case 'energy':
          url = this.commonService.getDailyEnergyReportUrl(this.siteId, selecteddate);
          // url = this.commonService.getDailyEnergyReportUrl('JAPBOSCH30201064', '2018-11-26');
          break;
        default:
          url = this.commonService.getgenerateDailySolarReportUrl(this.siteId, selecteddate);
          break;
      }

     

      // console.log('URL: ' + url);

      this.dataService.getPDF(url, true).subscribe((response) => {
        if (response.byteLength > 0) {
          const file = new Blob([response], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL, '_blank');
        } else {
          this.alertService.message = 'No data response !';
          this.alertService.showError();
        }

      });

    }
  }
}
